<template>
  <card-wrapper>
    <intents-usages-charts :is-loading="isLoading"
                           :intents="chartIntents"
                           :total-requests="totalRequests"
                           :total-intents="totalIntents"
                           :total-published-intents="totalPublishedIntents"
                           :get-series-data="getSeriesData"
    />
    <intents-usages-table id="intentUsagesTable"
                          :intents="publishedIntents"
                          :total-requests="totalRequests"
                          class="px-8 pb-10 border-0 border-t border-solid border-gray-a10"
                          :is-loading="isLoading"
                          :get-series-data="getSeriesData"
                          :bot-id="botId"
                          full-title-break-point="2xl"
    />
  </card-wrapper>
</template>

<script>
import CardWrapper from '@/components/base-components/CardWrapper'
import IntentsUsagesCharts from '@/components/analytics/charts/IntentsUsagesCharts'
import IntentsUsagesTable from '@/components/analytics/IntentsUsagesTable'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'IntentUsages',

  components: {
    IntentsUsagesTable,
    CardWrapper,
    IntentsUsagesCharts
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    botId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      totalIntents: 0,
      totalPublishedIntents: 0,
      publishedIntents: [],
      chartIntents: [],
      intentsTable: [],
      aggregatedOutcomesChart: [],
      aggregatedOutcomesTable: []
    }
  },

  watch: {
    isLoading() {
      if (!this.isLoading) {
        this.totalIntents = this.intentUsages.length
        this.publishedIntents = this.intentUsages.filter(({ answerPublished }) => answerPublished)
        this.totalPublishedIntents = this.publishedIntents.length
        this.setChartIntents()
        this.setAggregatedOutcomes(this.publishedIntents, 'aggregatedOutcomesTable')
        this.setAggregatedOutcomes(this.chartIntents, 'aggregatedOutcomesChart')
      }
    }
  },

  computed: {
    intentUsages: analyticsModule.getIntentUsages,

    totalRequests() {
      return this.publishedIntents.reduce((total, { outcomes }) => {
        return total + outcomes.reduce((intentTotal, { count, legendType }) => legendType ? intentTotal + count : intentTotal, 0)
      }, 0)
    }
  },

  methods: {
    setChartIntents() {
      // keep answers that are published OR have usage; exclude only the unpublished + unused.
      // a most-used answer that gets unpublished should still appear here (usage is historical).
      const filtered = this.intentUsages.filter(({
        usage,
        answerPublished
      }) => answerPublished || !!usage)
      const sorted = filtered.sort((a, b) => (b.usage || 0) - (a.usage || 0))
      this.chartIntents = sorted.slice(0, 5)
    },

    setAggregatedOutcomes(intents, dataProperty) {
      this[dataProperty] = intents.map(({ outcomes }) => outcomes)
    },

    // series => e.g. [1, 2 , 7, 4] => all not automated data per intent
    getSeriesData(outcomeType, isTable) {
      const aggregatedOutcomes = isTable ? this.aggregatedOutcomesTable : this.aggregatedOutcomesChart
      return aggregatedOutcomes.map(intentOutcomeTypes => {
        return (intentOutcomeTypes.find(({ legendType }) => legendType === outcomeType)?.count || 0) / this.totalRequests * 100
      })

    }
  }
}
</script>
